/**
 * New Activity Store - Pinia
 * 
 * Manages the state of a new GPS recording activity.
 * Migrated from VueX module src/store/modules/newActivity/
 */

import { defineStore } from 'pinia';
import GeoMoverDB from '@/db/geoMoverDB';

export const useNewActivityStore = defineStore('newActivity', {
  state: () => ({
    // started, finished, paused, resumed, interrupted
    status: 'idle',
    // recording new route: true/false/"paused"
    recording: false,
    // Data object to be saved
    id: -1,
    title: '',
    startTime: null,
    endTime: null,
    typeId: -1,
    typeName: '',
    geoData: [],
    // Current activity object
    newActivity: null,
    newActivityStatus: 'idle',
    // Array to save currently recorded geodata to
    tmpCoords: [],
    // Extended geojson data for properties
    tmpCoordsExt: [],
    // Distance object
    totalDistance: {
      feet: '0.000',
      inches: '0.000',
      km: '0.000',
      m: '0.000',
      miles: '0.000',
      seamiles: '0.000',
      yards: '0.000'
    },
    speed: 0,
    totalSteps: {},
    // Prevent clicking on menus while recording
    savedOrDeleted: true,
    // Track-level recording settings (captured once at recording start)
    recordingSettings: null
  }),

  getters: {
    getRecording: (state) => state.recording,
    getTmpCoords: (state) => state.tmpCoords,
    getTmpCoordsExt: (state) => state.tmpCoordsExt,
    getTotalDistance: (state) => state.totalDistance,
    getSpeed: (state) => state.speed,
    getTotalSteps: (state) => state.totalSteps,
    getSavedOrDeleted: (state) => state.savedOrDeleted,
    getRecordingSettings: (state) => state.recordingSettings
  },

  actions: {
    /**
     * Create a new activity and save to DB
     */
    async createNewActivity (payload) {
      const id = await GeoMoverDB.addOne('activities', payload);
      if (parseInt(id) > -1) {
        payload.id = id;
        this.newActivity = payload;
        this.newActivityStatus = 'started';
      }
    },

    finishNewActivity () {
      this.newActivityStatus = 'finished';
    },

    pauseNewActivity () {
      this.recording = false;
      this.newActivityStatus = 'paused';
    },

    resumeNewActivity () {
      this.recording = true;
      this.newActivityStatus = 'resumed';
    },

    setRecording (payload) {
      this.recording = payload;
    },

    /**
     * Save temporary coordinates during recording
     */
    saveTmpCoords (payload) {
      this.tmpCoords.push(payload[0]);
      this.tmpCoordsExt.push(payload[1]);
    },

    clearTmpCoords () {
      this.tmpCoords = [];
      this.tmpCoordsExt = [];
      this.recordingSettings = null;
    },

    setTotalDistance (obj) {
      this.totalDistance = obj;
    },

    setSpeed (int) {
      this.speed = int;
    },

    setTotalSteps (obj) {
      this.totalSteps = obj;
    },

    setSavedOrDeleted (payload) {
      this.savedOrDeleted = payload;
    },

    /**
     * Set track-level recording settings (captured once at recording start)
     */
    setRecordingSettings (settings) {
      this.recordingSettings = settings;
    }
  }
});
